<template>
  <div>
    <b-overlay :show="loading" rounded="sm" :style="loading ? 'height:800px;overflow:hidden;' : ''">
      <PageValidate ref="PricingTradeInfo">
        <template v-slot:PageBody>

          <div class="CenterCard">
            <BasicPageTop :Name="$t('lbl_EMPBE_ProductInfo_PricingTradeInformation')">
              <template v-slot:Body>
                <div class="BasicTop-Card" v-html="$t('lbl_EMPBE_ProductInfo_PricingTradeInformation_Blue_p')">
                </div>
              </template>
            </BasicPageTop>
            <div>
              <div class="row">
                <div class="col-12">
                  <PricingDisplay :modelValue="price"></PricingDisplay>
                  <ProductFieldApprovalResults usage-type="ProductPriceDisplay" />
                </div>
              </div>
              <!-- <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    Pricing Display
                  </div>
                </div>
                <div class="col-12">
                  <switchIput class="mt-2" ControlId="priceDisplay" :left="$t('lbl_EMPBE_Yes')"
                    :right="$t('lbl_EMPBE_No')" v-model="form.priceDisplay">
                  </switchIput>
                </div>
              </div>

              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left_BigText">
                    US$ 0.00 / Piece
                  </div>
                </div>
                <div class="MoreDivInLine_3 col-12">
                  <div class="MoreDivInLine_Row">
                    <selection ContolId="currencyUnit" :title="'Currency Unit'" v-model="form.currencyUnit" label="text"
                      :options="SelectOptions.LeadTimeOptions">
                    </selection>
                  </div>
                  <div class="MoreDivInLine_Row">
                    <textbox type="number" v-model="form.minPrice" :rules="{ min_value: 1 }" ControlId="minPrice"
                      :title="'minPrice'" NoMultipleMin="false"></textbox>
                  </div>
                  <div class="MoreDivInLine_Row">
                    <textbox type="number" v-model="form.maxPrice" :rules="{ min_value: 1 }" ControlId="maxPrice"
                      :title="'maxPrice'" NoMultipleMin="false"></textbox>
                  </div>
                  <div class="symbol">
                    /
                  </div>
                  <div class="MoreDivInLine_Row">
                    <selection ContolId="unit" :title="'Unit'" v-model="form.unit" label="text"
                      :options="SelectOptions.LeadTimeOptions">
                    </selection>
                  </div>
                </div>
                <div class="col-12">
                  <input id="priceRange" type="checkbox" v-model="form.priceRange"><label class="text-muted"
                    for="priceRange">Display a price range</label>
                </div>
              </div> -->


              <div class="row" v-if="AplusABCBooth">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{$t('lbl_EMPBE_ProductInfo_PricingTradeInformation_MOQ')}} 
                    <!-- <span class="text-danger">*</span> -->
                  </div>
                </div>
                <div class="MoreDivInLine_8 col-12">
                  <div class="MoreDivInLine_Row">
                    <textbox v-if="form.moqUnit == null || form.moqUnit == ''" ControlId="moqNumber" id="moqNumber" :title="$t('lbl_EMPBE_ProductInfo_PricingTradeInformation_MOQ_PlaceOther')" 
                    v-model="form.moqNumber" type="number"   :rules="{  min_value: 1 }"
                    :mandatory="$t('lbl_EMPBE_ProductInfo_PricingTradeInformation_MOQ') + $t('lbl_IsRequire')"
                    >
                    </textbox>
                    <textbox v-else ControlId="moqNumber" id="moqNumber" :title="$t('lbl_EMPBE_ProductInfo_PricingTradeInformation_MOQ_PlaceOther')" 
                    v-model="form.moqNumber" type="number"   :rules="{ required: true, min_value: 1 }"
                    :mandatory="$t('lbl_EMPBE_ProductInfo_PricingTradeInformation_MOQ') + $t('lbl_IsRequire')"
                    >
                    </textbox>
                  </div>
                  <div class="MoreDivInLine_Row">
                    <selection v-if="form.moqNumber" ContolId="moqUnit" :title="$t('lbl_EMPBE_Unit')" v-model="form.moqUnit" label="text"
                      :options="SelectOptions.UOMOptions"
                      :mandatory="$t('lbl_EMPBE_Unit') + $t('lbl_IsRequire')"
                      >
                    </selection>
                    <selection v-else ContolId="moqUnit" :title="$t('lbl_EMPBE_Unit')" v-model="form.moqUnit" label="text"
                      :options="SelectOptions.UOMOptions"
                      >
                    </selection>
                  </div>
                </div>
                <div class="col-12">
                  <ProductFieldApprovalResults usage-type="MOQ_Unit_Other" />
                </div>
                <div class="col-12" v-if="form.moqUnit == 99">
                  <div class="allow"><img :src="CompanyInfoCdnURL + 'Polygon.svg'"></div>
                  <div class="cardContent">
                    <div class="cardContent_title cardContent_title_Other">
                                {{ $t('lbl_EMPBE_CompanyInfo_Basic_Other') }}
                    </div>
                    <textbox ControlId="moqUnitOther" :title="$t('lbl_EMPBE_CompanyInfo_Basic_Other_PlaceOther')" max="30"
                      style="margin-bottom: 0px !important;" v-model="form.moqUnitOther"
                      :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_Other_PlaceOther') + $t('lbl_IsRequire')"></textbox>
                  </div>
                </div>
              </div>

              <div class="row" v-if="AplusABCBooth">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{$t('lbl_EMPBE_ProductInfo_PricingTradeInformation_ShippingPort')}}
                  </div>
                </div>
                <div class="col-12">
                  <selection ContolId="shippingPortCountry" :title="$t('lbl_EMPBE_ProductInfo_PricingTradeInformation_Country')" v-model="form.shippingPortCountry"
                    label="text" :options="SelectOptions.countryOptions">
                  </selection>
                </div>
                <div class="MoreDivInLine_8 col-12" v-if="IsChainaCode">
                  <div class="MoreDivInLine_Row">
                    <selection ContolId="shippingPortProvince" :title="$t('lbl_EMPBE_Province')" v-model="form.shippingPortProvince"
                      label="text" :options="SelectOptions.ProvOptions">
                    </selection>
                  </div>
                  <div class="MoreDivInLine_Row">
                    <selection ContolId="shippingPortCity" :title="$t('lbl_EMPBE_City')" v-model="form.shippingPortCity" label="text"
                      :options="GetCityOptions">
                    </selection>
                  </div>
                </div>
                <div class="MoreDivInLine_8 col-12" v-if="!IsChainaCode && !IsChainaHKcode">
                  <div class="MoreDivInLine_Row">
                    <textbox ControlId="shippingPortCityEN" :title="$t('lbl_EMPBE_ProductInfo_PricingTradeInformation_PortCityEn')" max="30"
                      v-model="form.shippingPortCityEN"></textbox>
                  </div>
                  <div class="MoreDivInLine_Row">
                    <textbox ControlId="shippingPortCityCN" :title="$t('lbl_EMPBE_ProductInfo_PricingTradeInformation_PortCityCn')" max="30"
                      v-model="form.shippingPortCityCN"></textbox>
                  </div>
                </div>
              </div>

              <div class="row" v-if="AplusABCBooth">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{$t('lbl_EMPBE_ProductInfo_PricingTradeInformation_LeadTime')}}
                  </div>
                </div>
                <!-- <div class="col-12 LeadTime">
                  Please update this part whenever the delivery time of your product has changed.
                </div> -->
                <div class="col-12">
                  <selection ContolId="leadTime" :title="$t('lbl_EMPBE_ProductInfo_PricingTradeInformation_LeadTime_PlaceOther')" v-model="form.leadTime"
                    label="text" :options="SelectOptions.LeadTimeOptions">
                  </selection>
                </div>
              </div>
            </div>
          </div>

        </template>
      </PageValidate>
    </b-overlay>
  </div>

</template>

<script>
import { productService } from "@/_services/product.service";
import { LogService } from "../../../_services/log.Service";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import PricingDisplay from "../../../components/PricingDisplay.vue";
import BasicPageTop from "./BasicPageTop.vue"
import ProductFieldApprovalResults from "../ProductFieldApprovalResults.vue";
export default {
  components: {
    BasicPageTop, PricingDisplay, ProductFieldApprovalResults
  },
  props: ["supplierId", "ProductId", "SelectOptions", "permissionData","PageLeaveType", "submitType"],
  data() {
    return {
      privateProductId: this.ProductId,
      loading: false,
      IsCreated: false,
      CompanyInfoCdnURL: "https://cdn.adsalecdn.com/EMP/Backend/svg/CompanyInfo/",
      form:
      {
        empCompanyId: "",
        productId: "",
        priceDisplay: "true",
        currencyUnit: "",
        minPrice: "",
        maxPrice: "",
        unit: "",
        priceRange: false,
        moqNumber: null,
        moqUnit: null,
        moqUnitOther: "",
        shippingPortCountry: "",
        shippingPortProvince: "",
        shippingPortCity: "",
        shippingPortCityEN: "",
        shippingPortCityCN: "",
        leadTime: ""
      },
      price: {
        ProductPriceDisplay: true,
        ProductPriceCurrUnit: "1",
        ProductPriceAmount: undefined,
        ProductPriceAmountMax: undefined,
        ProductPriceItemUnit: "4",
        ProductPriceRange: false,
        ProductPriceItemUnitOther: ''
      },
      disabledDates: {
      },
    };
  },
  watch: {
    'form.shippingPortProvince'(){
      if (!this.IsCreated) {
        this.form.shippingPortCity ='';
      }
    },
    supplierId: {
      handler() {
        this.InitData();
      },
      deep: true,
    },
    form: {
      handler() {
        if (!this.IsCreated) {
          this.$store.state.dirty = true;
        }
      },
      deep: true,
    },
    price: {
      handler() {
        if (!this.IsCreated) {
          this.$store.state.dirty = true;
        }
      },
      deep: true,
    },
    ProductId: {
      handler(newVal) {
        this.privateProductId = newVal;
      }
    },
  },
  computed: {
    useFormalTables() {
      return String(this.submitType || 'edit').toLowerCase() === 'approval';
    },
    IsChainaCode() {
      return this.form.shippingPortCountry == '44' || this.form.shippingPortCountry == '';
    },
    IsChainaHKcode() {
      return this.form.shippingPortCountry == '96' || this.form.shippingPortCountry == '125' || this.form.shippingPortCountry == '206';
    },
    GetCityOptions() {
      return this.SelectOptions.cityOptions.filter(item => item.provCode == this.form.shippingPortProvince)
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    user() {
      return this.$store.state.authentication.user;
    },
    AplusABCBasicBooth() {
      if (this.permissionData) {
        return ["A+","A", "B", "C", "Member"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    AplusABCBooth() {
      if (this.permissionData) {
        console.log("this.permissionData",this.permissionData);
        return ["A+","A", "B", "C"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    reactiveProductId() {
      return this.privateProductId && this.privateProductId > 0 ? this.privateProductId : (this.$route.params.id || 0);
    },
  },
  mounted() {
    this.InitData();
  },
  methods: {
    InitData() {
      this.GetData();
      this.resetFormVerify();
      setTimeout(() => {
        this.$store.state.dirty = false;
      }, 200);
    },
    GetData() {
      this.loading = true;
      this.IsCreated = true;
      productService.GetPricingAndTradeInfo({ companyId: this.supplierId, ProductId: this.reactiveProductId, useFormalTables: this.useFormalTables }).then(res => {
        if (res.isSuccessful) {
          this.form = res.data ?? { ...this.form, productId: this.reactiveProductId };
          this.price.ProductPriceDisplay = this.form.priceDisplay != "true" ? false : true;
          this.price.ProductPriceRange = this.form.priceRange === "true" ? true : false;
          this.price.ProductPriceCurrUnit = this.form.currencyUnit ?  this.form.currencyUnit : this.price.ProductPriceCurrUnit;
          this.price.ProductPriceAmount = this.form.minPrice ?  this.form.minPrice :  this.price.ProductPriceAmount;
          this.price.ProductPriceAmountMax = this.form.maxPrice ?  this.form.maxPrice :  this.price.ProductPriceAmountMax;
          this.price.ProductPriceItemUnit = this.form.unit   ?  this.form.unit : this.price.ProductPriceItemUnit;
          this.price.ProductPriceItemUnitOther = this.form.priceItemUnitOther ?  this.form.priceItemUnitOther : this.price.ProductPriceItemUnitOther;
          console.log("price",this.price)
        }
        setTimeout(() => {
          this.IsCreated = false;
        }, 500);
        //this.loading = false;
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      })
    },
    //重置表单验证
    resetFormVerify() {
      this.$refs.PricingTradeInfo.reset();
    },
    //整理結果提交save
    async AfterSaveResult(isSubmit) {
      var data =
      {
        EmpCompanyId: this.supplierId,
        ProductId: this.reactiveProductId ?? 0,
        PriceDisplay: this.price.ProductPriceDisplay,
        CurrencyUnit: this.price.ProductPriceCurrUnit,
        MinPrice: this.price.ProductPriceAmount,
        MaxPrice: this.price.ProductPriceAmountMax,
        Unit: this.price.ProductPriceItemUnit,
        PriceItemUnitOther: this.price.ProductPriceItemUnitOther,
        PriceRange: this.price.ProductPriceRange,
        MOQNumber: this.form.moqNumber,
        MOQUnit: this.form.moqUnit,
        MOQUnitOther: this.form.moqUnitOther,
        ShippingPortCountry: this.form.shippingPortCountry,
        ShippingPortProvince: this.form.shippingPortProvince,
        ShippingPortCity: this.form.shippingPortCity,
        ShippingPortCityEN: this.form.shippingPortCityEN,
        ShippingPortCityCN: this.form.shippingPortCityCN,
        LeadTime: this.form.leadTime,
        VaildError: [], //验证失败的filed
        validationErrorLog: "" //验证的errorlog
      }

      this.$submitFormMessage.ShowProgressWithoutUploadPopup({ isSubmit });

      return data;

    },

    LogPageFormError(errorLogObj, action) {
      LogService.LogFormErrorWithObj({
        EmpCompanyId: this.supplierId,
        EmpProductId: this.reactiveProductId,
        PageName: this.$route.path.split("/")[1],
        SectionName: "PricingTradeInfo",
        Action: action,
      }, errorLogObj);
    },

    //保存
    async Save() {
      var data = await this.AfterSaveResult(false);
      //写日志
      const query = {
        FormId: this.reactiveProductId,
        Action: 'Before_Save',
        FormType: 'ProductInfo_Pricing',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);
      
      return new Promise((resolve, reject) => {
        productService.SavePricingAndTradeInfo(data).then(res => {
          if (res.isSuccessful) {
            this.privateProductId = res.data;
            this.InitData();
            resolve({ data: res.data, state: true }); //用以确定当前不管作为修改亦或者添加id 都作为data 返回
          } else {
            this.LogPageFormError({ res: res }, 'Save_SavePricingAndTradeInfo');
            reject({
              message: this.$t("lbl_EMPBE_Save_Failed_HasErrorAndCode", { code: res.statusCode, msg: res.msg?.join(",") || "Error" })
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack }, 'Save_SavePricingAndTradeInfo');
          reject({
            message: this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: err.message })
          });
        })
      });

    },
    //提交
    async Submit() {
      var data = await this.AfterSaveResult(true);

      const query = {
        FormId: this.reactiveProductId,
        Action: 'Before_Submit',
        FormType: 'ProductInfo_Pricing',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);

      return new Promise((resolve, reject) => {
        productService.SavePricingAndTradeInfo(data).then(result => {
          if (result.isSuccessful) {
            this.privateProductId = result.data;
            const newProductId = !this.$route.params.id || this.$route.params.id == 0 ? result.data : 0; // For adding new product id when reject

            this.$refs.PricingTradeInfo
            .validate(true)
            .then(async (res) => {

              //写日志
              data.VaildError = res.fIldData;

              if (res.valid) 
              {
                this.InitData();
                resolve({ data: result.data, isAllMandatoryFieldsFilled: true });
              }
              else
              { 
                this.GetData();
                resolve({ data: result.data, isAllMandatoryFieldsFilled: false });
              }

            });
          }
          else
          {
            this.LogPageFormError({ result: result }, 'Submit_SavePricingAndTradeInfo');
            reject({
              message: this.$t("lbl_EMPBE_Submit_Failed_HasErrorAndCode",{code:result.statusCode,msg:result.msg?.join(",") || "Error"})
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack }, 'Submit_SavePricingAndTradeInfo');
          reject({
            message: this.$t("lbl_EMPBE_Submit_Failed_HasError",{ msg: err.message })
          });
        });
      });
    }
  },
};
</script>
<style>
.templateImg {
  height: 150px;
  object-fit: cover;
  object-position: top;
}
</style>